/*
  this is the "head" entry point for webpack
  files imported here are compiled into head.js or head.css
  see webpack.config.js for configuration
*/

// VENDOR STUFF
import $ from 'jquery';
window['jQuery'] = $;
window['$'] = $;
import * as Cookies from 'js-cookie/src/js.cookie.js';
window['Cookies'] = Cookies;
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

// OUR STUFF
window.idx = {};
